// extracted by mini-css-extract-plugin
export default {"content":"UO-z","lookName":"VO-z","shopTheLookContainer":"WO-z","productContainer":"XO-z","imageContainer":"YO-z","mainImage":"ZO-z"};